<template>
  <sec-section>
    <sec-section-heading :eyebrow="problem.eyebrow" :title="problem.title" />
    <sec-card-grid :items="cards" badge-style="chip" min="300px" />
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecCardGrid from '@/components/security/ui/SecCardGrid.vue';
import { HOME } from '@/content/security/home';

const problem = HOME.problem;
// Three cards (same style as About's core values), numbered 01, 02, 03.
const cards = problem.items.map((item, i) => ({ ...item, badge: String(i + 1).padStart(2, '0') }));
</script>
